
import { Link } from 'react-router-dom';

export default function PopularDramas() {
  // Example data – replace with real data or props as needed
  const dramas = [
    { id: 1, title: 'Crash Landing on You' },
    { id: 2, title: 'Goblin' },
    { id: 3, title: 'Itaewon Class' },
  ];

  return null;
}
